import { FormGroup } from '@angular/forms';

/** Normalise une valeur métier/secteur (string ou objet API `{ name }`). */
export function jobFormFieldText(value: unknown): string {
    if (value == null) {
        return '';
    }
    if (typeof value === 'object' && value !== null && 'name' in value) {
        return String((value as { name: unknown }).name ?? '').trim();
    }
    return String(value).trim();
}

/** Affichage liste / sélection : première lettre en majuscule (comme `displayJob`). */
export function formatJobFormDisplayText(text: string): string {
    const normalized = text.trim();
    if (!normalized) {
        return '';
    }
    return normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();
}

/** Métier et secteur renseignés (indépendant de `jobForm.valid` / statut DISABLED). */
export function isJobFormComplete(jobForm: FormGroup): boolean {
    const raw = jobForm.getRawValue() as { job?: unknown; business?: unknown };
    return !!jobFormFieldText(raw.job) && !!jobFormFieldText(raw.business);
}
